module.exports = __webpack_public_path__ + "first-10-glossy_stripe.jpg?71ae398951d5675282886cb017aea8a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10-glossy_stripe.jpg
// module id = 400
// module chunks = 0